export type MediaType = "video" | "image" | "file";

export interface Media {
  id: string;
  type: MediaType;
  url: string;
  key: string;
  fileName: string;
  contentType: string;
  fileSize?: number;
  duration?: number;
  downloadable?: boolean;
  createdAt: Date;
}

export interface UploadProgress {
  fileName: string;
  progress: number;
  status: "uploading" | "success" | "error";
  error?: string;
}

export const ALLOWED_VIDEO_TYPES = ["video/mp4", "video/quicktime"];
export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
export const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/zip",
  "application/x-rar-compressed",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const ALLOWED_VIDEO_EXTENSIONS = [".mp4", ".mov"];
export const ALLOWED_IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp"];
export const ALLOWED_FILE_EXTENSIONS = [
  ".pdf",
  ".zip",
  ".rar",
  ".ppt",
  ".pptx",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
];

export const MAX_FILE_SIZE = {
  video: 2 * 1024 * 1024 * 1024, // 2GB - รองรับวิดีโอความยาว 30-60 นาที
  image: 10 * 1024 * 1024, // 10MB
  file: 50 * 1024 * 1024, // 50MB
};
